import {Button, Dropdown, Form, InputGroup, Modal, Stack} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useOrderBy2, useSearchTerm, useTouch} from "../../hooks";
import React, {useState} from "react";

export function MenuBar({children}) {
    return <Stack direction="horizontal" gap="1" className="py-2 pb-sm-4 align-items-start">
        {children}
    </Stack>
}

export function MenuAdd({to, children, icon}) {
    return <Button as={Link} to={to} variant="success" className="flex-shrink-0">
        {children ? <span className="d-none d-sm-block">{children}</span> : <span className={`bi bi-${icon} d-none d-sm-block`}/>}
        <span className={`bi bi-${icon} d-block d-sm-none`}/>
    </Button>
}

export function MenuOrderBy({orderOptions}) {

    const [order, setOrder] = useOrderBy2()

    return <Dropdown onSelect={setOrder} className="flex-shrink-0">
        <Dropdown.Toggle variant="primary" id="dropdown-order-by">
            <span className="d-none d-sm-inline">{orderOptions.find(o => o.order === order)?.name || "Orders by"}</span>
            <i className="bi bi-arrow-down-up d-sm-none"/>
        </Dropdown.Toggle>
        <Dropdown.Menu>
            {orderOptions.map(o =>
                <Dropdown.Item key={o.order} eventKey={o.order} active={o.order === order}>{o.name}</Dropdown.Item>
            )}
        </Dropdown.Menu>
    </Dropdown>
}

export function MenuSearchTerm() {
    const touch = useTouch()
    const [filter, handleOnClear, handleOnChange, handleKeyUp, showFilterHelp] = useSearchTerm()

    return <InputGroup hasValidation>
        <Form.Control id="FilterId" name="filter" placeholder="Search..." autoComplete="off"
                      value={filter} autoFocus={!touch}
                      onChange={handleOnChange} onKeyUp={handleKeyUp}
                      isValid={showFilterHelp}/>
        <Button variant="outline-secondary" onClick={handleOnClear}><i className="bi bi-x-lg"/></Button>
        <Form.Control.Feedback type="valid">Type enter to search globally...</Form.Control.Feedback>
    </InputGroup>
}

export function MenuClearSelectButton({onClick, hide = false, children}) {
    if (hide)
        return null

    return <Button variant="secondary" onClick={onClick} className="flex-shrink-0">
        <i className="bi bi-x-lg"/>
        {children && <span className="d-none d-sm-inline flex-shrink-0"> {children}</span>}
    </Button>
}

export function MenuEditButton({onClick, hide = false, children}) {
    if (hide)
        return null

    return <Button variant="primary" onClick={onClick} className="flex-shrink-0">
        {children && <span className="d-none d-sm-inline flex-shrink-0">{children}</span>}
    </Button>
}

export function MenuConfirmDeleteButton({label = "Delete", onSubmit, loading, hide = false, variant = "danger", children}) {

    const [showModal, setShowModal] = useState(false)

    const [firstChild, secondChild] = React.Children.toArray(children)

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const handleDelete = () => {
        if (typeof onSubmit === "function")
            onSubmit()
        handleClose()
    }

    if (hide)
        return null

    return <>
        <Button variant={variant} onClick={handleShow} disabled={loading} className="flex-shrink-0">
            <span className="d-none d-sm-inline">{label}</span>
            <i className="bi bi-trash d-sm-none"/>
        </Button>

        <Modal show={showModal} onHide={handleClose} backdrop="static" keyboard={true} restoreFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                By clicking <i className="text-danger">I am sure, delete {firstChild}</i>, your action cannot be reverted.
                {secondChild}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Go back</Button>
                <Button variant="danger" onClick={handleDelete}>I am sure, delete {firstChild}</Button>
            </Modal.Footer>
        </Modal>
    </>
}